<template lang="pug">
  b-badge(:variant="variant") {{public_status}}
</template>

<script>
export default {
  name: "OrderStatusBadge",
  props: {
    status: {
      type: String,
      default: 'unknown',
    }
  },
  computed:{
    variant(){
      if (this.status === 'composing') return 'danger';
      if (this.status === 'new') return 'danger';
      if (this.status === 'working') return 'warning';
      if (this.status === 'confirmed') return 'success';
      if (this.status === 'completed') return 'dark';
      return 'secondary';
    },
    public_status(){
      if (this.status === 'composing') return 'Формируется';
      if (this.status === 'new') return 'Новый';
      if (this.status === 'working') return 'В работе';
      if (this.status === 'confirmed') return 'Подтвержден';
      if (this.status === 'completed') return 'Завершен';
      if (this.status === 'canceled') return 'Отменен';
      return this.status;
    }
  }
}
</script>

<style scoped>

</style>